// Styles
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";
import "vuetify/dist/vuetify.min.css";
import * as components from "vuetify/lib/components";
import * as directives from "vuetify/lib/directives";

// Vuetify
import { createVuetify } from "vuetify";

export default createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: "light",
    themes: {
      light: {
        colors: {
          background: "#ffffff",
          surface: "#ffffff",
          primary: "#7c3aed", // violet-600
          secondary: "#a78bfa", // violet-400
          accent: "#8b5cf6", // violet-500
          error: "#ef4444",
          info: "#3b82f6",
          success: "#10b981",
          warning: "#f59e0b",
          "on-background": "#1f2937", // gray-800 for good contrast
          "on-surface": "#1f2937", // gray-800 for good contrast
          "on-primary": "#ffffff",
          "on-secondary": "#ffffff",
          "on-error": "#ffffff",
          "on-info": "#ffffff",
          "on-success": "#ffffff",
          "on-warning": "#ffffff",
        },
      },
    },
  },
});
// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
// https://next.vuetifyjs.com/en/components/all/
